module.exports = __webpack_public_path__ + "img/index-price.b17e2648.jpg";